import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"; 
import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css';
// import ReactHtmlParser from 'react-html-parser';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../../configs/urlConfigs';
import { MSG_SKILL_REQUIRED, MSG_SKILL_DOC_REQUIRED, MSG_SKILL_ADD_SUCCESS, MSG_SKILL_UPDATE_SUCCESS, MSG_SKILL_DELETE_SUCCESS, MSG_SKILL_INDEX_UPDATE_ERROR} from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_SKILLS, LBL_SKILL, LBL_BTN_ADDNEW, LBL_EDIT_SKILL, LBL_ADD_SKILL, LBL_SLNUM, LBL_CERTIFICATE_MANDATORY, LBL_CERTIFICATE_NEEDED, LBL_ACTIVE, LBL_ACTION, LBL_EDIT, LBL_DELETE,LBL_CONFIRM_DELETE} from '../../../configs/labelConfigs';
import {LOGIN_AFFILIATE_GROUP, PAGENUMROWS_AFFILIATE,  PAGING_END_INDEX, ROUTE_AFFILIATE_REFRESH,} from '../../../configs/staticConfigs'; // ROUTE_REFRESH,

import ModalWindow from '../../commons/helpers/modalWindow';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';

import {formValid} from '../../../utils/validation'; 


import { aflt_skillListAction, aflt_skillAddAction, aflt_skillUpdateAction, aflt_skillDeleteAction, updateSkillIndexAction } from '../../../actions/settings/affiliates/aflt_skillActions';
import { SKILL_ADD_AFFILIATE_SUCCESS, SKILL_ADD_AFFILIATE_ERROR,  SKILL_UPDATE_AFFILIATE_SUCCESS, SKILL_UPDATE_AFFILIATE_ERROR, SKILL_DELETE_AFFILIATE_SUCCESS, SKILL_DELETE_AFFILIATE_ERROR,SKILL_LIST_AFFILIATE_SUCCESS, UPDATE_SKILL_INDEX_SUCCESS, UPDATE_SKILL_INDEX_ERROR} from '../../../actions'; 

import {clearAction} from '../../../actions/commonActions';

const range = len => {
    const arr = [];
    for (let i = 0; i < len; i++) {
      arr.push(i);
    }
    return arr;
  };
  
const newPerson = () => {
    const statusChance = Math.random();
    return {
      slnum: Math.floor(Math.random() * 12),
      skills: Math.floor(Math.random() * 15),
      certificate: Math.floor(Math.random() * 30),
      active: Math.floor(Math.random() * 100),
      progress: Math.floor(Math.random() * 100),
      action: 'Single',
    };
  };
  
export function makeData(len = 12) {
    return range(len).map(d => {
      return {
        ...newPerson(),
        // children: range(10).map(newPerson)
      };
    });
  }

  class DragTrComponent extends React.Component {
    render() {
      const { children = null, rowInfo } = this.props;
      if (rowInfo) {
        const { original, index } = rowInfo;
        const { slnum } = original;
        return (
          <Draggable key={slnum} index={index} draggableId={slnum}>
            {(draggableProvided, draggableSnapshot) => (
              <div
                ref={draggableProvided.innerRef}
                {...draggableProvided.draggableProps}
                {...draggableProvided.dragHandleProps}
              >
                <ReactTable.defaultProps.TrComponent style={{ width: '100%' }}>
                  {children}
                </ReactTable.defaultProps.TrComponent>
              </div>
            )}
          </Draggable>
        );
      } else
        return (
          <ReactTable.defaultProps.TrComponent  >
            {children}
          </ReactTable.defaultProps.TrComponent>
        );
    }
  }
  
  class DropTbodyComponent extends React.Component {
    render() {
      const { children = null } = this.props;
  
      return (
        <Droppable droppableId="droppable">
          {(droppableProvided, droppableSnapshot) => (
            <div ref={droppableProvided.innerRef}>
              <ReactTable.defaultProps.TbodyComponent  >
                {children}
              </ReactTable.defaultProps.TbodyComponent>
            </div>
          )}
        </Droppable>
      );
    }
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };
  
class AfltSkillComponent extends Component { 

    constructor(props){
        super(props)

        let profileId = '';

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup    = ''; 
        let grpProfileId = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            grpProfileId = userGroupData.profile_id;
        }

        if(userGroup===LOGIN_AFFILIATE_GROUP){
            profileId = grpProfileId;
        }else{
            profileId = this.props.match.params.id;
        }

        this.state = {
            formErrors : {}, 
            skillList: [],  
            skillList_newIndex: [],
            skillId: 0,
            skillName: '', 
            isCertificateMandatory: '', 
            certificateName: '', 
            isSkillActive: true, 
            skillData: {},
            formErrMsg_skillName: '',
            formErrMsg_CertName: '',
            formErrMsg_AddEdit: '',
            activePage:1,
            startIndex : 0, 
            endIndex : 3,
            perPageCount:2, //PAGENUMROWS_AFFILIATE,
            activeRowId:0,            
            sortField:'skill_name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            profileId:profileId,
            data: makeData(),
            numSkills:0
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        // this.onSort = this.onSort.bind(this);
        this.checkFormData = this.checkFormData.bind(this); 
        this.modalDelete = React.createRef();
        this.modalConfirmDelete = React.createRef();
        this.modal = React.createRef();
    }

    handleDragEnd = result => {
        if (!result.destination) {
          return;
        }
    
        const skillList = reorder(
          this.state.skillList,
          result.source.index,
          result.destination.index
        );
        
        let newObj = []; 
        let indexDataObj = [];
        skillList.forEach((item, index) => {
            item.slnum = String((index+1))
            item.index = String((index+1))
            newObj.push(item);
            indexDataObj.push({skill_id: Number(item.id), index: Number(index+1)}); 
        })

        this.props.updateSkillIndexAction(indexDataObj); 
        // [{"skill_id": 102, "index": 7}, {"skill_id": 101, "index": 2}, {"skill_id": 97, "index": 3}]
        this.setState({ skillList_newIndex:newObj});
    };
      

    getTrProps = (state, rowInfo) => {
        //  console.log(rowInfo);
        return { rowInfo };

        // let rowInfoNew = rowInfo; 
        // let style = {
        //     background: 'red',
        //     color: 'black'
        // };
        // rowInfoNew.style = style; 
        // return {  
        //     style: {
        //         background: 'red',
        //         color: 'black'
        //     }
        //  }
        // return { rowInfo };
    };

    componentDidMount() { 
        document.body.classList.add('body-affiliate'); 
        this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField}); 
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" -  "+LBL_SKILLS+' - Pay rates and certification'; 
    }   
    
    openModal(refId) {
        if(!refId) {
            this.setState({skillId:0, skillName:'', isCertificateMandatory:'', certificateName:'', isSkillActive:true, formErrMsg_skillName:'', formErrMsg_CertName: '', formErrMsg_AddEdit: ''});
        }        
        this.modal.current.handleOpenModal();
    }  

    onModalFormReset = () =>{   
        this.setState({skillId:0, skillName:'', isCertificateMandatory:'', certificateName:'', isSkillActive:true, formErrMsg_skillName:'', formErrMsg_CertName: '', formErrMsg_AddEdit: ''});   
        this.props.clearAction();  
    }

    onModalConfirmReset = () =>{
        this.modalDelete.current.handleModelClose();
        this.setState({skillId:0, skillName:'', isCertificateMandatory:'', certificateName:'', isSkillActive:true, formErrMsg_skillName:'', formErrMsg_CertName: '', formErrMsg_AddEdit: ''});
        this.props.clearAction();  
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
        }  
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+sortKey});
        }        
    }

    onPagePrevious = (e) =>{
        const { startIndex, endIndex } = this.state
        let previousPage = startIndex+1-PAGING_END_INDEX
        this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:previousPage,column:this.state.sortOrder+this.state.sortField});
        if(startIndex===0){
            this.setState({
                activePage: previousPage,
                startIndex : startIndex,
                endIndex : endIndex
            });  
        }else{
            this.setState({
                activePage: previousPage,
                startIndex : startIndex - PAGING_END_INDEX,
                endIndex : endIndex - PAGING_END_INDEX
            });  
        }                               
    }

    onPageUp = (e) => {      

        this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:e.target.id,column:this.state.sortOrder+this.state.sortField});
   
 
        this.setState({
            activePage: Number(e.target.id)                   
        });
    }
    
    onPageNext = (e) =>{   
        const { startIndex,endIndex } = this.state;      
        const { totalPage } = this.props;      
        let nextPage = startIndex+1+PAGING_END_INDEX;
        this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:nextPage,column:this.state.sortOrder+this.state.sortField});
        if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
            this.setState({
                activePage: nextPage,
                startIndex : startIndex,
                endIndex : endIndex
            }); 
        }else{
            this.setState({
                activePage: nextPage,
                startIndex : startIndex + PAGING_END_INDEX,
                endIndex : endIndex + PAGING_END_INDEX
            });  
        }                            
    }

    editBtnClick = (refId) =>{  
        this.props.skillsList.map((rObj) => {
            if(refId===rObj.id) {
                let mand = (rObj.certificate_mandatory) ? 'yes' : 'no'; 
                this.setState({skillId:refId, skillName:rObj.skill_name, basePayRate:rObj.base_pay_rate, chargeRate:rObj.charge_rate, isCertificateMandatory:mand, certificateName:rObj.certificate_name, isSkillActive:rObj.is_active, formErrMsg_skillName:'', formErrMsg_BPayRate:'', formErrMsg_chargeRate:'', formErrMsg_CertName: '', formErrMsg_AddEdit: ''});
                this.openModal(refId);
            }
            return console.log('.'); 
        }); 
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({skillId: rowId,skillName:name}); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        this.props.aflt_skillDeleteAction({skillId:this.state.skillId});              
    }

    onDeleteConfrimAction = () =>{
        this.props.aflt_skillDeleteAction({skillId:this.state.skillId,confirm:true});              
    }
    
    onHandleChange = (event) =>{
        const {name, value} = event.target; 
        let errMsg = ''; 
        let valStr = value.trim(); 
        if(name==='txt_skillName') {
            errMsg = valStr.length <=0 ? MSG_SKILL_REQUIRED : ''; 
            this.setState({formErrMsg_AddEdit: '', skillName:value, formErrMsg_skillName:errMsg});  
        }
        else if(name==='sel_isCertificateMandatory') {
            let cMand = (valStr==='yes') ? true : false;  
            errMsg = ((cMand) && (this.state.certificateName==='')) ? MSG_SKILL_DOC_REQUIRED : ''; 
            this.setState({formErrMsg_AddEdit: '', isCertificateMandatory:valStr, formErrMsg_CertName:errMsg});  
        } 
        else if(name==='txt_certificateName') {
            let cMand = this.state.isCertificateMandatory;  
            errMsg = (cMand==='yes') && (valStr==='') ? MSG_SKILL_DOC_REQUIRED : ''; 
            this.setState({formErrMsg_AddEdit: '', certificateName:value, formErrMsg_CertName:errMsg});  
        } 
        else if(name==='chk_isSkillActive') {
            let chkd = (event.target.checked) ? true : false;  
            this.setState({formErrMsg_AddEdit: '', isSkillActive:chkd});  
        } 
    }  

    checkFormData() {
        if(this.state.skillName.trim()==='') {
            this.setState({formErrMsg_AddEdit: '', formErrMsg_skillName:MSG_SKILL_REQUIRED});  
            return false; 
        }
        else if(this.state.isCertificateMandatory==='yes' && this.state.certificateName.trim()==='') { 
            this.setState({formErrMsg_AddEdit: '', formErrMsg_CertName:MSG_SKILL_DOC_REQUIRED});  
            return false; 
        } 
        else {
            return true; 
        }
    }

    onSaveFormData = (refId) =>{
        if(formValid(this.state)){
            let userGroupData = userGroupUrlCheck(this.props.location);
            let grpProfileId = '';
            if(userGroupData!==undefined){
                grpProfileId = userGroupData.profile_id;
            }  
            if(refId){ // EDIT 
                if(this.checkFormData()) { 
          
                    let affiliate = grpProfileId;
                    let tmpSkillData= {
                        id: refId,
                        skill_name: this.state.skillName, 
                        certificate_name: this.state.certificateName,  
                        certificate_mandatory: this.state.isCertificateMandatory==='yes' ? true : false,  
                        is_active: this.state.isSkillActive,
                        affiliate: affiliate 
                    } 
                    this.props.aflt_skillUpdateAction(tmpSkillData);
                       
                }
            } else if(this.checkFormData()) {
               
                let affiliate = grpProfileId;
                let tmpSkillData= {
                    skill_name: this.state.skillName, 
                    certificate_name: this.state.certificateName,  
                    certificate_mandatory: this.state.isCertificateMandatory==='yes' ? true : false, 
                    is_active: this.state.isSkillActive,
                    affiliate: affiliate 
                } 
                this.props.aflt_skillAddAction(tmpSkillData);                  
                
            }    
        }else{
            // let formErrors = this.state.formErrors;
            // if(this.state.sectorData.sectorName==null){
            //     formErrors.sectorName = MSG_SECTOR_REQUIRED;
            // }            
            // this.setState({formErrors});
        }
    }

    componentDidUpdate(prevProps) {       
        const { status, activity, numRows, totalPage,errorData } = this.props;

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            var arrResp = activity.split('~~'); 
            var actString = arrResp[0]; 
            let errMsg = '';
            
            
            if(actString===UPDATE_SKILL_INDEX_SUCCESS) { 
                let skillList = this.state.skillList_newIndex; 
                this.setState({skillList:skillList});
            }
            else if(actString===UPDATE_SKILL_INDEX_ERROR) { 
                this.setToasterState(true,MSG_SKILL_INDEX_UPDATE_ERROR,false);
                console.log(JSON.stringify(errorData))
            }

            if(actString===SKILL_LIST_AFFILIATE_SUCCESS) { 
                let skillList = []; 
                let len = 0; 
                if(this.props.skillsList && Array.isArray(this.props.skillsList) && this.props.skillsList.length) {
                    len = this.props.skillsList.length; 
                    skillList = [];
                    this.props.skillsList.forEach((rObj, index) => {
                        rObj.slnum = String((index+1));
                        rObj.certificate_mandatory = rObj.certificate_mandatory ? 'Y' : 'N';
                        rObj.is_active = rObj.is_active ? 'Y' : 'N';
                        rObj.action = String(rObj.id);
                        skillList.push(rObj)
                    })
                }

                // rObj.action = '<div className="dropdown" id={"dropdown-'+rObj.id+'"}> <button className="dropdown-toggle" type="button" id={"dropdownMenuButton-'+rObj.id+'"}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(e) => this.onShowActionButtons(e, '+rObj.id+')} onBlur={(e) => this.onHideActionButtons(e, '+rObj.id+')} > <img src={require("../../../'+URL_IMG+'action.png")} alt="Action" /> </button> <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton-'+rObj.id+'"} id={"dropdown-menu-'+rObj.id+'"}><Link className="dropdown-rObj edit" to="#"  onMouseDown={(e) => this.editBtnClick(rObj.id)}>Edit</Link> <Link className="dropdown-rObj delete" to="#" onMouseDown={(e)=>this.deleteBtnClick('+rObj.id+','+rObj.skill_name+')}>Delete</Link></div></div>';
                 

                this.setState({skillList,numSkills:len})
                //console.log('this.props.skillsList'); 
                //console.log(this.props.skillsList); 
            }

            if(actString===SKILL_ADD_AFFILIATE_SUCCESS) { 
                this.onModalFormReset();
                this.modal.current.handleModelClose();
                this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});
                this.setState({formErrMsg_AddEdit: '', toastFlag:true,toastMessage:MSG_SKILL_ADD_SUCCESS}); 
                setTimeout(()=> { this.onCloseToast(); }, 3000);
            }else if(actString===SKILL_ADD_AFFILIATE_ERROR) { 
                if(status===400){
                    if(errorData.hasOwnProperty('skill_name')){
                        errMsg = errorData.skill_name[0]; 
                    }else{
                        this.modal.current.handleModelClose();
                        this.setToasterState(true,JSON.stringify(errorData),false);
                    }                
                    this.setState({formErrMsg_AddEdit: errMsg, formErrMsg_skillName: '', formErrMsg_BPayRate: '', formErrMsg_chargeRate: '', formErrMsg_CertName: ''}); 
                }else{
                    this.modal.current.handleModelClose();
                    if(errorData.hasOwnProperty('message')){ 
                        this.setToasterState(true,errorData.message,false);
                    }else{
                        this.setToasterState(true,JSON.stringify(errorData),false);
                    }   
                }
                
            }else if(actString===SKILL_UPDATE_AFFILIATE_SUCCESS){ 
                this.onModalFormReset();
                this.modal.current.handleModelClose();
                this.setState({formErrMsg_AddEdit: '', toastFlag:true,toastMessage:MSG_SKILL_UPDATE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);          
            }else if(actString===SKILL_UPDATE_AFFILIATE_ERROR){ 
                if(status===400){
                    if(errorData.hasOwnProperty('skill_name')){
                        errMsg = errorData.skill_name[0]; 
                    }else{
                        this.modal.current.handleModelClose();
                        this.setToasterState(true,JSON.stringify(errorData),false);
                    }                
                    this.setState({formErrMsg_AddEdit: errMsg, formErrMsg_skillName: '', formErrMsg_BPayRate: '', formErrMsg_chargeRate: '', formErrMsg_CertName: ''}); 
                }else{
                    this.modal.current.handleModelClose();
                    if(errorData.hasOwnProperty('message')){ 
                        this.setToasterState(true,errorData.message,false);
                    }else{
                        this.setToasterState(true,JSON.stringify(errorData),false);
                    }   
                }      
            }else if(actString===SKILL_DELETE_AFFILIATE_SUCCESS){ 
                this.modalDelete.current.handleModelClose();
                this.modalConfirmDelete.current.handleModelClose();

                if (numRows===1 && totalPage > 1){
                    let page = this.state.activePage-1;
                    this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:page,column:this.state.sortOrder+this.state.sortField});
                }else{
                    this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});
                }                
                this.setState({toastFlag:true,toastMessage:MSG_SKILL_DELETE_SUCCESS});
                setTimeout(()=> { this.onCloseToast(); }, 3000); 
            }else if(actString===SKILL_DELETE_AFFILIATE_ERROR){ 
                if(status===424){
                    this.modalDelete.current.handleModelClose();
                    this.setToasterState(true,errorData.message,false); 
                    // this.modalConfirmDelete.current.handleOpenModal();
                    // if(errorData.hasOwnProperty('confirmation_message')){
                    //     if(errorData.confirmation_message===true){
                    //         this.setState({skillId:errorData.id});
                    //     }else{
                    //         this.setState({skillId:0});
                    //     }
                    // }
                }else{
                    this.modalDelete.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false); 
                }
            }
        }
    }

    onSelect = (rowInfo, column) => {

    }
       
    render(){
        const {
            activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,data          
        } = this.state

        const { skillsList, totalPage, status} = this.props;   
        
        if(status===401 || status===403){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }

        return(
            <>
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>

                    <div className="box-content">
                        {Number(this.state.numSkills)===0 &&  
                        <DragDropContext onDragEnd={this.handleDragEnd}>
                            <ReactTable
                                showPagination={false}
                                TrComponent={DragTrComponent}
                                TbodyComponent={DropTbodyComponent}
                                getTrProps={this.getTrProps}
                                data={[]}
                                columns={[
                                    {   accessor: "slnum",
                                        Header: () => ( <div className="table-header-center">{LBL_SLNUM}</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> ) 
                                    },  
                                    {   accessor: d => d.skill_name,
                                        id: "skill_name",   
                                        Header: () => ( <div className="table-header-left">{LBL_SKILLS}</div>),
                                        Cell: row => ( <div className="table-td-text-left">{row.value}</div> )
                                    },
                                    {   accessor: "certificate_mandatory",
                                        Header: () => ( <div className="table-header-center">Certificate Mandatory?</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> )
                                    },
                                    {   accessor: "certificate_name",
                                        Header: () => (<div className="table-header-left">Certificate Needed</div>),
                                        Cell: row => ( <div className="table-td-text-left">{row.value}</div> )
                                    },
                                    {   accessor: "is_active",
                                        Header: () => (<div className="table-header-center">Active</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> )
                                    },
                                    {   accessor: "action",
                                        Header: () => (<div className="table-header-center">Action</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> )
                                    }
                                ]}
                                defaultPageSize={2}
                                className="table -striped -highlight"
                            />
                        </DragDropContext>}

                        {Number(this.state.numSkills) > 0 && <DragDropContext onDragEnd={this.handleDragEnd}>
                            <ReactTable
                                showPagination={false}
                                TrComponent={DragTrComponent}
                                TbodyComponent={DropTbodyComponent}
                                getTrProps={this.getTrProps}
                                data={this.state.skillList}
                                getTdProps={(state, rowInfo, column, instance) => ({
                                    style: {
                                        cursor: 'pointer',
                                        overflow: 'visible'
                                    },
                                    onClick: () => this.onSelect(rowInfo, column)
                                })}
                                columns={[
                                    {   accessor: "slnum",
                                        Header: () => ( <div className="table-header-center">{LBL_SLNUM}</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> ) 
                                    },  
                                    {   accessor: d => d.skill_name,
                                        id: "skill_name",   
                                        Header: () => ( <div className="table-header-left">{LBL_SKILLS}</div>),
                                        Cell: row => ( <div className="table-td-text-left">{row.value}</div> )
                                    },
                                    {   accessor: "certificate_mandatory",
                                        Header: () => ( <div className="table-header-center">{LBL_CERTIFICATE_MANDATORY}</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> )
                                    },
                                    {   accessor: "certificate_name",
                                        Header: () => (<div className="table-header-left">{LBL_CERTIFICATE_NEEDED}</div>),
                                        Cell: row => ( <div className="table-td-text-left">{row.value}</div> )
                                    },
                                    {   accessor: "is_active",
                                        Header: () => (<div className="table-header-center">{LBL_ACTIVE}</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> )
                                    },
                                    {   accessor: "action",
                                        Header: () => (<div className="table-header-center">{LBL_ACTION}</div>),
                                        Cell: row => ( 
                                            <table className="overflow-visible"><tr className="overflow-visible"><td className="overflow-visible"><div className="table-td-text-center"><div className="dropdown" id={"dropdown-"+row.value+'index'}> <button className="dropdown-toggle" type="button" id={"dropdownMenuButton-"+row.value+'index'}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(e) => this.onShowActionButtons(e, row.value+'index')} onBlur={(e) => this.onHideActionButtons(e, row.value+'index')} > <img src={require("../../../"+URL_IMG+"action.png")} alt="Action" style={{zIndex:999, position:'relative'}} /> </button> </div><div className="dropdown-menu" aria-labelledby={"dropdownMenuButton-"+row.value+'index'} id={"dropdown-menu-"+row.value+'index'}><Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.editBtnClick(row.value+'index')}>{LBL_EDIT}</Link> <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(row.value+'index',row.value)}>{LBL_DELETE}</Link></div></div></td></tr></table>
                                          )
                                    }
                                ]} 
                                defaultPageSize={Number(this.state.numSkills)}
                                className="table"
                            />
                        </DragDropContext> } 
                                {/*  <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton-"+row.value+'index'} id={"dropdown-menu-"+row.value+'index'}><Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.editBtnClick(row.value+'index')}>{LBL_EDIT}</Link> <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(row.value+'index',row.value)}>{LBL_DELETE}</Link></div>

                                
                                
                                
                                 */}
                    </div>


                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton-1339index" id="dropdown-menu-1339index"><a class="dropdown-item edit" href="/affiliate/skillsdnd">Edit</a> <a class="dropdown-item delete" href="/affiliate/skillsdnd">Delete</a></div>
                    

                    {/* <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th onClick={(e) => this.onSort(e,'skill_name')} className="sorting_asc">{LBL_SKILLS}</th>
                                        <th className="text-center">{LBL_CERTIFICATE_MANDATORY}</th>
                                        <th>{LBL_CERTIFICATE_NEEDED}</th>
                                        <th className="text-center">{LBL_ACTIVE}</th>
                                        <th className="action">{LBL_ACTION}</th>
                                        <th >&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody> 
                                    {skillsList.map((item,index) => { 
                                    return (
                                        <tr key={item.id}>
                                            <td>{(PAGENUMROWS_AFFILIATE*(this.state.activePage-1))+(index+1)}</td>
                                            <td>{item.skill_name}</td>
                                            <td className="text-center">{(item.certificate_mandatory) ? 'Y' : 'N'}</td>
                                            <td>{item.certificate_name}</td>
                                            <td className="text-center">{(item.is_active) ? 'Y' : 'N'}</td>
                                            <td>
                                                <div className="dropdown" id={'dropdown-'+item.id}>
                                                    <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-'+item.id}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                    onBlur={(e) => this.onHideActionButtons(e, item.id)} >
                                                    <img src={require('../../../'+URL_IMG+'action.png')} alt="Action" />
                                                    </button>
                                                    <div className="dropdown-menu" aria-labelledby={'dropdownMenuButton-'+item.id} id={'dropdown-menu-'+item.id}>
                                                    <Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                    <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.skill_name)}>{LBL_DELETE}</Link>
                                                    </div>
                                                </div>
                                            </td>
                                            <td >&nbsp;</td>
                                        </tr>
                                    ) } ) }
                                </tbody>
                            </table>
                            <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                            <div className="clear-b-scroll-sector">&nbsp;&nbsp;</div>

                        </div>
                    </div> */}
                </div>

                

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete skill '"+this.state.skillName+"'?"}
                </ModalWindow>

                <ModalWindow ref={this.modalConfirmDelete} header={LBL_CONFIRM_DELETE} type="confirm" deleteConfirmedItem={this.onDeleteConfrimAction} resetModalForm={this.onModalConfirmReset}>
                This skill has already been used in another module, do you still want to delete this record?
                </ModalWindow>

                <ModalWindow ref={this.modal} header={this.state.skillId ? LBL_EDIT_SKILL: LBL_ADD_SKILL} saveFormData={ (e)=>this.onSaveFormData(this.state.skillId)} resetModalForm={this.onModalFormReset}>

                    <div className="row">
                        <div className="col-md-6">
                           <div className="form-group">
                              <label>{LBL_SKILL}</label>
                              <div className="text-input"><input type="text" placeholder=" " name="txt_skillName" value={this.state.skillName} onChange={this.onHandleChange} maxLength = {120} className={this.state.formErrMsg_skillName.length > 0 ? "input-error" : ''}  /></div> 
                              {this.state.formErrMsg_skillName.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrMsg_skillName}</div>
                                )} 
                                {this.state.formErrMsg_AddEdit.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrMsg_AddEdit}</div>
                                    )} 
                           </div>
                        </div>
                        
                        <div className="col-md-6">
                           <div className="form-group">
                              <label>Is certificate mandatory ?</label>
                              <div className="form-group select-input">
                                 <select name="sel_isCertificateMandatory" value={this.state.isCertificateMandatory} onChange={this.onHandleChange} >
                                    <option value="no">No</option>
                                    <option value="yes" >Yes</option>
                                </select>
                             </div>
                           </div>
                        </div>
                     </div> 
                        
                     <div className="row">
                        <div className="col-md-6">
                           <div className="form-group">
                              <label>Certificate Name</label>
                              <div className="text-input"><input type="text" placeholder="" name="txt_certificateName" value={this.state.certificateName} onChange={this.onHandleChange} className={this.state.formErrMsg_CertName.length > 0 ? "input-error" : ''} /></div>
                              {this.state.formErrMsg_CertName.length >0 && (
                                <div className="text-red left-align text-12">{this.state.formErrMsg_CertName}</div>
                                )} 
                           </div>
                        </div>
                        <div className="col-md-6">
                               <div className="form-group custom-checkbox mt-4 pt-2">
                                   <input type="checkbox" name="chk_isSkillActive" id="chk_isSkillActive" checked={this.state.isSkillActive ? true : false} onChange={this.onHandleChange} />
                                   <label className="checkbox" htmlFor="chk_isSkillActive"></label>
                                   <label className="labeltext" htmlFor="chk_isSkillActive">Active</label>
                                   
                                   
                               </div>
                        </div>
                     </div>

                </ModalWindow>

            </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    console.log('activity:'+state.afltSkills.activity); 
    return {
        skillsList : state.afltSkills.items,
        totalPage:state.afltSkills.totalPage,
        skill:state.afltSkills.item,
        status:state.afltSkills.status,
        activity:state.afltSkills.activity,
        numRows:state.afltSkills.numRows,
        errorData: state.afltSkills.errorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_skillListAction:aflt_skillListAction,  
        aflt_skillAddAction:data=>aflt_skillAddAction(data),
        aflt_skillUpdateAction:data=>aflt_skillUpdateAction(data),
        aflt_skillDeleteAction:id=>aflt_skillDeleteAction(id),
        updateSkillIndexAction:updateSkillIndexAction,
        clearAction:clearAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(AfltSkillComponent);
